(function () {

  function initFurPreloader() {

    const preloader =
      document.querySelector(
        '[data-fur-preloader]'
      );


    if (!preloader) {
      return;
    }


    const percentage =
      preloader.querySelector(
        '[data-fur-preloader-percentage]'
      );


    const percentageWrap =
      preloader.querySelector(
        '[data-fur-preloader-percentage-wrap]'
      );


    if (
      !percentage ||
      !percentageWrap
    ) {
      return;
    }


    document.documentElement.classList.add(
      'fur-is-loading'
    );


    document.body.classList.add(
      'fur-is-loading'
    );


    /* =====================================================
       SETTINGS
    ===================================================== */

    const minimumDuration =
      2200;


    const startTop =
      86;


    const endTop =
      20;


    let startTime =
      performance.now();


    let visualProgress =
      0;


    let pageLoaded =
      document.readyState ===
      'complete';


    let finished =
      false;


    /* =====================================================
       REAL PAGE LOAD
    ===================================================== */

    window.addEventListener(
      'load',
      function () {

        pageLoaded =
          true;

      },
      {
        once: true
      }
    );


    /* =====================================================
       EASING
    ===================================================== */

    function easeOutQuart(value) {

      return (
        1 -
        Math.pow(
          1 - value,
          4
        )
      );

    }


    /* =====================================================
       UPDATE POSITION
    ===================================================== */

    function updateVisuals(
      progress
    ) {

      const safeProgress =
        Math.max(
          0,
          Math.min(
            progress,
            1
          )
        );


      const number =
        Math.floor(
          safeProgress *
          100
        );


      percentage.textContent =
        number + '%';


      const eased =
        easeOutQuart(
          safeProgress
        );


      const currentTop =
        startTop +
        (
          endTop -
          startTop
        ) *
        eased;


      percentageWrap.style.top =
        currentTop +
        '%';

    }


    /* =====================================================
       ANIMATION
    ===================================================== */

    function animate() {

      if (finished) {
        return;
      }


      const now =
        performance.now();


      const elapsed =
        now -
        startTime;


      const timeProgress =
        Math.min(
          elapsed /
          minimumDuration,
          1
        );


      /*
       * Before the page has loaded,
       * let the animation progress naturally
       * but stop around 90%.
       */

      let targetProgress;


      if (pageLoaded) {

        targetProgress =
          1;

      } else {

        targetProgress =
          Math.min(
            timeProgress *
            0.92,
            0.92
          );

      }


      /*
       * Smoothly approach the target.
       */

      visualProgress +=
        (
          targetProgress -
          visualProgress
        ) *
        0.08;


      /*
       * Once the minimum display time
       * and actual page loading are done,
       * finish the remaining progress.
       */

      if (
        pageLoaded &&
        elapsed >=
          minimumDuration
      ) {

        visualProgress +=
          (
            1 -
            visualProgress
          ) *
          0.16;

      }


      if (
        visualProgress >
        0.997 &&
        pageLoaded &&
        elapsed >=
          minimumDuration
      ) {

        visualProgress =
          1;


        updateVisuals(
          1
        );


        finishPreloader();


        return;

      }


      updateVisuals(
        visualProgress
      );


      requestAnimationFrame(
        animate
      );

    }


    /* =====================================================
       FINISH
    ===================================================== */

    function finishPreloader() {

      if (finished) {
        return;
      }


      finished =
        true;


      percentage.textContent =
        '100%';


      percentageWrap.style.top =
        endTop +
        '%';


      window.setTimeout(
        function () {

          preloader.classList.add(
            'is-finished'
          );


          document.documentElement
            .classList.remove(
              'fur-is-loading'
            );


          document.body.classList.remove(
            'fur-is-loading'
          );


          window.setTimeout(
            function () {

              preloader.remove();

            },
            500
          );

        },
        300
      );

    }


    /* =====================================================
       START
    ===================================================== */

    updateVisuals(
      0
    );


    requestAnimationFrame(
      animate
    );


    /*
     * Safety fallback.
     * Customer should never get stuck.
     */

    window.setTimeout(
      function () {

        if (!finished) {

          pageLoaded =
            true;


          visualProgress =
            1;


          updateVisuals(
            1
          );


          finishPreloader();

        }

      },
      7000
    );

  }


  /* =======================================================
     INITIALIZE
  ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initFurPreloader,
      {
        once: true
      }
    );

  } else {

    initFurPreloader();

  }

})();